import type { TenantProfile } from '@hetivo/hetivo-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useTenantProfileQueryOptions } from '&/api/tenant-profile';

export function useTenantProfile(): UseQueryResult<TenantProfile> {
  return useQuery(useTenantProfileQueryOptions());
}
